<agpr-master-layout [id]="'social'">
    <!-- Don't show the sidebar -->
    <ng-template agprTemplate="navigation">
    </ng-template>
</agpr-master-layout>
